export default "__VITE_ASSET__CecDtp9t__"